module.exports = __webpack_public_path__ + "img/XVG-alt.8f556408.svg";